// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container styling for the instructions table */
.instructions-container {
    margin-left: 250px;
    padding: 16px;
    max-width: 90%; /* Limit the container width */
    width: calc(100% - 280px); /* Adjust based on sidebar width */
    background: #FFFFFF;
    border-radius: 12px;
    margin-bottom: 60px; /* Adds extra space at the bottom for the button */
}

/* Styling for the instructions table */
.instructions-table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
}

.instructions-table th,
.instructions-table td {
    padding: 16px;
    border-bottom: 1px solid #DFE7EF;
    font-size: 16px;
    color: #4B5563;
}

.instructions-table th {
    font-weight: bold;
    background-color: #F9FAFB;
}

/* Button styling */
.view-button,
.edit-button,
.delete-button,
.add-button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
}

.view-button {
    background-color: #FF0000;
    color: white;
}
.view-button:hover {
    background-color: #E60000;
}

.edit-button {
    background-color: #00A8E8;
    color: white;
}
.edit-button:hover {
    background-color: #007BB5;
}

.delete-button {
    background-color: #FF0000;
    color: white;
}
.delete-button:hover {
    background-color: #E60000;
}

/* Fixed positioning for the "Add New" button */
.add-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 10;
    padding: 12px 20px;
    background-color: #FF0000;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s;
}

/* Modal styling */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-content {
    background: #FFFFFF;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/style/Instructions.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc,EAAE,8BAA8B;IAC9C,yBAAyB,EAAE,kCAAkC;IAC7D,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB,EAAE,kDAAkD;AAC3E;;AAEA,uCAAuC;AACvC;IACI,WAAW;IACX,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;;;;IAII,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;;AAEA,+CAA+C;AAC/C;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":["/* Container styling for the instructions table */\n.instructions-container {\n    margin-left: 250px;\n    padding: 16px;\n    max-width: 90%; /* Limit the container width */\n    width: calc(100% - 280px); /* Adjust based on sidebar width */\n    background: #FFFFFF;\n    border-radius: 12px;\n    margin-bottom: 60px; /* Adds extra space at the bottom for the button */\n}\n\n/* Styling for the instructions table */\n.instructions-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-family: Arial, sans-serif;\n}\n\n.instructions-table th,\n.instructions-table td {\n    padding: 16px;\n    border-bottom: 1px solid #DFE7EF;\n    font-size: 16px;\n    color: #4B5563;\n}\n\n.instructions-table th {\n    font-weight: bold;\n    background-color: #F9FAFB;\n}\n\n/* Button styling */\n.view-button,\n.edit-button,\n.delete-button,\n.add-button {\n    padding: 8px 16px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.view-button {\n    background-color: #FF0000;\n    color: white;\n}\n.view-button:hover {\n    background-color: #E60000;\n}\n\n.edit-button {\n    background-color: #00A8E8;\n    color: white;\n}\n.edit-button:hover {\n    background-color: #007BB5;\n}\n\n.delete-button {\n    background-color: #FF0000;\n    color: white;\n}\n.delete-button:hover {\n    background-color: #E60000;\n}\n\n/* Fixed positioning for the \"Add New\" button */\n.add-button {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 10;\n    padding: 12px 20px;\n    background-color: #FF0000;\n    color: #FFFFFF;\n    font-size: 14px;\n    font-weight: bold;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n/* Modal styling */\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.modal-content {\n    background: #FFFFFF;\n    padding: 20px;\n    border-radius: 8px;\n    width: 400px;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
